export default "__VITE_ASSET__f88ce0eb__"